import { useState, useRef, useEffect } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { ChevronDown, Search } from 'lucide-react';

const CurrencySelector = () => {
  const { currency, changeCurrency, currencies } = useCurrency();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = currencies.filter(c =>
    c.code.toLowerCase().includes(search.toLowerCase()) ||
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  const current = currencies.find(c => c.code === currency);

  return (
    <div className="relative" ref={ref} data-testid="currency-selector">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium bg-white/60 hover:bg-white border border-[rgba(28,36,30,0.12)] transition-colors"
        data-testid="currency-selector-btn"
      >
        <span className="font-bold">{current?.symbol}</span>
        <span>{currency}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-64 bg-white border border-[rgba(28,36,30,0.12)] rounded-xl shadow-lg z-50 overflow-hidden" data-testid="currency-dropdown">
          <div className="p-2 border-b border-[rgba(28,36,30,0.06)]">
            <div className="relative">
              <Search className="absolute left-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-[#5C6B61]" />
              <input
                type="text" value={search} onChange={e => setSearch(e.target.value)}
                placeholder="Search currency..."
                className="w-full pl-7 pr-2 py-1.5 text-xs border border-[rgba(28,36,30,0.12)] rounded-lg focus:outline-none focus:border-[#D96C4A]"
                autoFocus data-testid="currency-search-input"
              />
            </div>
          </div>
          <div className="max-h-60 overflow-y-auto">
            {filtered.map(c => (
              <button
                key={c.code}
                onClick={() => { changeCurrency(c.code); setOpen(false); setSearch(''); }}
                className={`w-full flex items-center gap-2 px-3 py-2 text-xs hover:bg-[#F0EFEB] transition-colors ${
                  currency === c.code ? 'bg-[#F0EFEB] font-medium' : ''
                }`}
                data-testid={`currency-option-${c.code}`}
              >
                <span className="w-8 text-right font-bold text-[#D96C4A]">{c.symbol}</span>
                <span className="font-medium">{c.code}</span>
                <span className="text-[#5C6B61] truncate">{c.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
